import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledBlogItem = styled.div`
  margin: 0 auto;
  max-width: 740px;
  padding: 20px;

  .blog-item {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .image-container {
      position: relative;
      height: 400px;
      border-radius: 10px;
      overflow: hidden;
    }

    .blog-date {
      margin-top: 5px;
    }

    .description {
      a {
        color: ${Colors.primary};
      }
      img {
        max-width: 100%;
        object-fit: contain;
      }
    }
  }
`;
